<ul class="product-menu__card-list">
  <li
    *ngFor="let product of productService.products$ | async"
    class="product-menu__card-item"
  >
    <!-- Flag driven disabled, in the future we can choose not to hide if it's disabled -->
    @if(product.url.startsWith('/')) {
    <a
      [routerLink]="product.url"
      [style.pointer-events]="product.disabled ? 'none' : 'all'"
    >
      <ng-container
        *ngTemplateOutlet="cardContent; context: { $implicit: product }"
      ></ng-container>
    </a>
    } @else {
    <a
      [href]="product.url"
      [style.pointer-events]="product.disabled ? 'none' : 'all'"
      ><ng-container
        *ngTemplateOutlet="cardContent; context: { $implicit: product }"
      ></ng-container>
    </a>
    }
  </li>
</ul>

<ng-template #centralIcon>
  <div class="flex items-center" style="padding-bottom: 1em">
    <img [src]="centralLogo" alt="Central Logo" width="30" height="30" />
  </div>
</ng-template>

<ng-template #cardContent let-product>
  <p-card
    class="flex"
    [style.opacity]="product.disabled ? 0.5 : 1"
    [style.height]="'14em'"
  >
    @if (product.name === 'Central') {
    <div class="flex justify-content-between">
      <ng-container *ngTemplateOutlet="centralIcon"></ng-container>
      <p-tag value="Available Now" class="beta"></p-tag>
    </div>
    } @else {
    <fa-duotone-icon
      class="fad fa-2x product-menu__icon"
      [icon]="$any(product.icon)"
    >
    </fa-duotone-icon>
    }
    <h3 class="card-item__card-title">{{ product.name }}</h3>
    <p class="card-item__card-content">
      {{ product.description }}
    </p>
  </p-card>
</ng-template>
